import React, { useEffect, useState } from 'react'
import { RxCross2 } from 'react-icons/rx'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Header from '../components/header'
import SeriviceTable from '../components/serviceTable'
import AppLayout from '../components/AppLayout'
import { deleteBusinessServices, editBusinessServices, getBusinessServices } from '../logic/business/action'
import { IconButton } from '@mui/material'
import { ServicePopup } from './home'
import { MdRefresh } from 'react-icons/md'
import EditPatientForm from '../components/editpatient'
import EditServiceForm from '../components/editService'

const ServicesScreen = () => {
    // const dispatch = useDispatch();
    const [state, setState] = useState(0);
    const [stateForm, setStateForm] = useState({
      name:'',
      role:'',
      email:'',
      contact:'',
    });
    const [editMode, setEditMode] = useState(false);
    const [editId, setEditId] = useState(0);
    const [editModeIndi, setEditModeIndi] = useState(false);
    const [editModeIndiValue, setEditModeIndiValue] = useState('');
    const [editModeIndiLabel, setEditModeIndiLabel] = useState('');
    const [servicetodelete, setServicetodelete] = useState('');
    const [servicetoedit, setServicetoedit] = useState('');
    const [showConfirmationPopup, setShowConfirmationPopup] = useState('');
    const [showConfirmationPopupEdit, setShowConfirmationPopupEdit] = useState('');

    const selectorAuth = useSelector(state=>state.auth);
    const dispatch = useDispatch();
    const selector = useSelector(state=>state.auth);
    useEffect(() => {
        getBusinessServices(dispatch, selector?.user?.business_id);
    }, [selector?.user?.business_id]);

    const handleDeleteServiceMain =(id)=>{
      console.log(id)
      deleteBusinessServices(dispatch,id);
      setTimeout(() => {
        getBusinessServices(dispatch, selector?.user?.business_id);
    }, 300);
    
      // console.log(id);
    }
    const onSubmitedit = (data) =>{
      // const serviceId = id.service_id
      // const businessId = id.business_id
      // console.log(serviceId)
      // console.log(businessId)
      // console.log(data)
      const req ={
        id:data.id,
        business_id:data.business_id,
        service:data.service,
        charges:data.charges
      }
      console.log(req)
      editBusinessServices(dispatch,req)
      setTimeout(() => {
        getBusinessServices(dispatch, selector?.user?.business_id);
    }, 300);
    }
  return (
  <AppLayout>
  {
    editMode?
    <ServicePopup closePopup={()=>{
      getBusinessServices(dispatch, selector?.user?.business_id);
      setEditMode(false)}}/>
    :<></>
  }
  {showConfirmationPopup && (
    <div className="absolute top-[40%] left-1/2 transform -translate-x-1/2 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[40%] xl:w-[30%] flex flex-col z-50 bg-white text-black border-black border-[1px] pt-4 pb-4 pl-3 pr-3 rounded-lg">
    <h3 className=" text-left text-xl">Are you sure you want to delete this Service?</h3>
      <div className="flex flex-row justify-center mt-5">
      <button className=" bg-blue-600 pl-5 pr-5 pt-2 pb-2 text-white rounded-xl" onClick={() => setShowConfirmationPopup(false)}>No</button>
      <button className=" bg-red-600 pl-5 pr-5 pt-2 pb-2 text-white rounded-xl ml-5  "
        onClick={() => {
            handleDeleteServiceMain(servicetodelete);
            setShowConfirmationPopup(!showConfirmationPopup);
          }
        }
      >
        Yes
      </button>
      </div>
    </div>
  )}
        {servicetoedit ? (
        <div
          className={`h-screen w-screen bg-black/60 absolute z-50 ${
            servicetoedit ? "flex items-center justify-center" : "hidden"
          } `}
        >
          <div className="bg-white p-10 w-[50%] rounded-lg relative flex flex-col gap-2">
            <span
              className="absolute top-2 right-2 cursor-pointer"
              onClick={() => setServicetoedit((prev) => !prev)}
            >
              <RxCross2 size={24} />
            </span>
            <h4 className="font-bold text-xl text-blue-800 text-center ">
              {/* {state === 0 && "Edit Service"}
        {state === 1 && "Edit Staff Details"} */}
              {"Edit Service Details"}
              {/* {state === 3 && "Edit Appointment"}
        {state === 4 && "Edit Document"}
        {state === 5 && "Edit Field"} */}
            </h4>

            <>
            <EditServiceForm
              data={stateForm} 
              recordId={editId?.service_id}
              onCancel={() => setServicetoedit(false)}
              onSubmit={(values2) => {
                const data = {
                  ...values2,
                  id: editId.service_id,
                  business_id: editId.business_id
                }
                onSubmitedit(data);
              }}
            />
            </>
          </div>
        </div>
      ) : (
        <></>
      )}

  <div className="w-full h-full flex flex-col items-start gap-4 p-4">
    {/* <div className="w-full h-full"> */}
   <Header
   title={'Services'}
   middle={<IconButton onClick={()=>
    getBusinessServices(dispatch, selector?.user?.business_id)
  }>
    <MdRefresh/>
   </IconButton>}
   actions={<>

<IconButton onClick={()=>{
                setEditMode(true);
   }}>
   <span
              onClick={() => {
              }}
              className="bg-primary text-center rounded-full text-white w-10 h-10 flex items-center justify-center"
            >
              <span className="-mt-1 text-2xl" >
              +
              </span>
            </span>
   </IconButton>
   </>}
   />
   <SeriviceTable 
   setEditMode={(data) => {
              setStateForm({...data})
              setEditMode((prev) => !prev)
              setEditId(data?.service_id);
            }}
  onDeleteServices={(data) => {
    setServicetodelete(data);
    setShowConfirmationPopup(true);
    }}
    setServicetoedit={(data)=>{
      setEditId(data);
      setServicetoedit((prev) => !prev)
      setStateForm({ ...data});
  }}  
    /> 
    </div>
  </AppLayout>
  )
}

export default ServicesScreen